// Assemble captured sides into ONE PDF (one page per side): JPEG/PNG embedded, PDF pages copied losslessly.
// pdf-lib is dynamically imported so it only loads when a two-sided document is actually combined.
export async function combineSidesToSinglePdf(orderedBlobs) {
	const { PDFDocument } = await import('pdf-lib');
	const out = await PDFDocument.create();

	for (const blob of orderedBlobs) {
		if (!blob) continue;
		const bytes = new Uint8Array(await blob.arrayBuffer());
		if (blob.type === 'application/pdf') {
			// ignoreEncryption copies pages from lightly-protected scans; a corrupt PDF throws → clean error upstream.
			const src = await PDFDocument.load(bytes, { ignoreEncryption: true });
			const pages = await out.copyPages(src, src.getPageIndices());
			pages.forEach((p) => out.addPage(p));
		} else if (blob.type === 'image/jpeg' || blob.type === 'image/png') {
			const img = blob.type === 'image/png' ? await out.embedPng(bytes) : await out.embedJpg(bytes);
			const page = out.addPage([img.width, img.height]);
			page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
		} else {
			throw new Error(`Unsupported side format: ${blob.type || 'unknown'}`);
		}
	}

	if (out.getPageCount() === 0) throw new Error('No document pages to combine');
	const pdfBytes = await out.save();
	return new Blob([pdfBytes], { type: 'application/pdf' });
}
